import useSummary from "./useSummary";

export default useSummary;
